import { UserCountry } from '@interfaces/index'
import { FETCH_COUNTRY_SUCCESS, FETCH_COUNTRY_FAILURE, FETCH_COUNTRY_REQUEST } from '../actions/userCountryActions'
import { FetchCountryFailure, FetchCountryRequest, FetchCountrySuccess } from '@actions-types/userCountryActionTypes'

export type CountryAction = FetchCountrySuccess | FetchCountryFailure | FetchCountryRequest
interface UserCountryState {
    data: UserCountry
    error?: string
    loading: boolean
}

const initialState = {
    data:{ countryCode: ''},
    error: '',
    loading:false
}

const countryReducer = (state: UserCountryState = initialState, action: CountryAction): UserCountryState => {
    switch (action.type) {
        case FETCH_COUNTRY_REQUEST:
            return { ...state, loading:true }
        case FETCH_COUNTRY_SUCCESS:
            return {
                ...state,
                data: (action as FetchCountrySuccess).payload,
                error: '',
                loading: initialState.loading
            }
        case FETCH_COUNTRY_FAILURE:
            return { ...state, error: (action as FetchCountryFailure).payload, loading:initialState.loading }
        default:
            return state
    }
}

export default countryReducer
